import {compose} from 'redux';
import {connect} from 'react-redux';
import {Field, reduxForm, reset} from 'redux-form';
import {Button, Form} from 'semantic-ui-react';
import {useToasts} from 'react-toast-notifications';
import moment from 'moment-jalaali';
import FormSelect from '../shared/forms/select';
import FormDatePicker from '../shared/forms/datepicker';
import FormTimePicker from '../shared/forms/timepicker';
import FormTextArea from '../shared/forms/textarea';
import {required} from '../shared/forms';
import {convertDatetimeToObject} from '../shared/forms/utils';
import {createReport} from '../../redux/actions/report';
import {getTypeText as _} from '../../utils/homeworks';
import './form.scss';

function ReportForm(props) {
  const {homeworkOptions, startTime, disabledDays, handleSubmit, submitting} = props;
  const {addToast} = useToasts();
  const successMessage = 'گزارش شما با موفقیت ثبت گردید.';

  return (
    <Form onSubmit={handleSubmit(submit.bind(null, props, addToast, successMessage))}>
      <Form.Group widths='equal' className='large'>
        <Field
          required
          name='date'
          label='تاریخ انجام'
          validate={required}
          component={FormDatePicker}
          minimumDate={convertDatetimeToObject(startTime)}
          maximumDate={convertDatetimeToObject()}
          disabledDays={disabledDays}
        />
        <Field
          required
          name='duration'
          label='مدت زمان انجام'
          validate={required}
          component={FormTimePicker}
        />
      </Form.Group>
      <Field
        multiple
        name='homeworks'
        label='تکالیف'
        component={FormSelect}
        options={homeworkOptions}
      />
      <Field
        name='description'
        label='توضیحات'
        component={FormTextArea}
      />
      <Button type='submit' disabled={submitting} content='ارسال'/>
    </Form>
  );
}

async function submit(props, addToast, successMessage, values) {
  try {
    await props.createReport(values);
    await props.reset();
    addToast(successMessage, {appearance: 'success'});
  } catch (e) {
    addToast(e.response.data['non_field_errors'], {appearance: 'error'});
  }
}

function mapStateToProps(state, {reports, homeworks, studentCourse}) {
  const homeworkOptions = homeworks.map(homework => ({
    key: homework.id,
    value: homework.id,
    text: `${homework.name} (${_(homework.type)})`
  }));
  const startTime = studentCourse['started'] || moment().subtract(10, 'days').format();
  const disabledDays = reports.map(report => convertDatetimeToObject(report.date));

  const initialValues = {duration: '00:00', homeworks: [], studentCourse: studentCourse.id};
  return {homeworkOptions, startTime, disabledDays, initialValues};
}

ReportForm.defaultProps = {homeworks: [], latestReports: []};

export default compose(
  connect(mapStateToProps, {createReport, reset}),
  reduxForm({form: 'report'})
)(ReportForm);
